import PropTypes from 'prop-types';
import { isUserWhoBlockedMe } from '../../../Helpers/Chat/BlockContact';

const UserStatus = ({ status, blocked, userId }) => {
    if (typeof blocked === 'undefined' && userId) {
        blocked = isUserWhoBlockedMe(userId);
    }

    if (blocked) return null;

    const userStatus = status;
    return (
        <span className="status" title={userStatus}>
            <span className="status-text">{userStatus}</span>
        </span>
    );
};

export default UserStatus;

UserStatus.propTypes = {
    status: PropTypes.string,
    blocked: PropTypes.bool,
    userId: PropTypes.string,
};
